import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 66.41 54.63' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M66.39.72V.46L66.2.33h-.06L66 .15h-.77L.58 25a.9.9 0 0 0 0 1.68L21 34.84 27.56 54a1 1 0 0 0 .06.12v.09a.89.89 0 0 0 .22.23h.09l.16.08a.88.88 0 0 0 .27 0h.36a.91.91 0 0 0 .19-.11 1 1 0 0 0 .16-.17L38 41.63l19.85 7.92a.91.91 0 0 0 1.23-.7L66.41 1V.91.83a.81.81 0 0 0-.02-.11zm-63 25.13L59.88 4 21.6 33.12zM28.27 50.5l-5.46-16L58.62 7.27 31.48 37.71a.91.91 0 0 0-.16.27v.1zm2.15-1.2l2.37-9.76 3.5 1.4zm27.06-1.85L33.69 38 64.16 3.78z'
        fill='undefined'
        data-name='general content'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/PaperPlaneIcon.js